/* ============================================================
   Janzen — Custom Sections Interaktionen
   Selbst-initialisierend; re-init im Theme-Editor via shopify:section:load.
   ============================================================ */
(function () {
  "use strict";

  function initReveal(root) {
    var els = root.querySelectorAll(".jz-reveal:not(.jz-bound)");
    if (!els.length) return;
    if (!("IntersectionObserver" in window)) {
      els.forEach(function (e) { e.classList.add("jz-in", "jz-bound"); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add("jz-in"); io.unobserve(e.target); } });
    }, { threshold: 0.12, rootMargin: "0px 0px -6% 0px" });
    els.forEach(function (e) { e.classList.add("jz-bound"); io.observe(e); });
  }

  /* ---- Varianten-/Material-Picker: Bild + Akzent + Label wechseln + Fullscreen-Modal ---- */
  function initPickers(root) {
    root.querySelectorAll("[data-jz-picker]:not(.jz-bound)").forEach(function (pick) {
      pick.classList.add("jz-bound");
      var stage = pick.querySelector(".jz-picker__stage");
      var label = pick.querySelector("[data-jz-picker-label]");
      var scope = pick.closest(".jz") || pick;
      pick.querySelectorAll(".jz-swatch").forEach(function (sw) {
        sw.addEventListener("click", function (e) {
          e.preventDefault();
          pick.querySelectorAll(".jz-swatch").forEach(function (s) { s.setAttribute("aria-pressed", "false"); });
          sw.setAttribute("aria-pressed", "true");
          var key = sw.getAttribute("data-key");
          if (stage) stage.querySelectorAll("img").forEach(function (img) {
            img.classList.toggle("jz-active", img.getAttribute("data-key") === key);
          });
          if (label) label.textContent = sw.getAttribute("data-name") || "";
          var ac = sw.getAttribute("data-accent");
          if (ac) scope.style.setProperty("--jz-accent-color", ac);
          var cta = pick.querySelector("[data-jz-picker-cta]");
          var ctaUrl = sw.getAttribute("data-cta-url");
          if (cta && ctaUrl) cta.setAttribute("href", ctaUrl);
        });
      });

      // Fullscreen-Modal: Fokus-Ansicht mit der gewählten Variante, direkt zur Karte gescrollt
      var openBtn = pick.querySelector("[data-jz-picker-open]");
      var dlg = pick.querySelector("[data-jz-picker-dialog]");
      if (openBtn && dlg) {
        bindDialog(dlg);
        openBtn.addEventListener("click", function () {
          var sel = pick.querySelector('.jz-swatch[aria-pressed="true"]') || pick.querySelector(".jz-swatch");
          if (sel) {
            var stageImg = dlg.querySelector("[data-jz-modal-stage]");
            var cutout = dlg.querySelector("[data-jz-modal-cutout]");
            var nameEl = dlg.querySelector("[data-jz-modal-name]");
            var priceEl = dlg.querySelector("[data-jz-modal-price]");
            var idInput = dlg.querySelector('form input[name="id"]');
            var imgL = sel.getAttribute("data-img-large");
            var cut = sel.getAttribute("data-cutout");
            var nm = sel.getAttribute("data-name");
            var pr = sel.getAttribute("data-price");
            var vid = sel.getAttribute("data-variant-id");
            if (stageImg && imgL) stageImg.src = imgL;
            if (cutout && cut) cutout.src = cut;
            if (nameEl && nm) nameEl.textContent = nm;
            if (priceEl && pr) priceEl.textContent = pr;
            if (idInput && vid) idInput.value = vid;
            var link = dlg.querySelector("[data-jz-picker-cta]");
            var ctaUrl = sel.getAttribute("data-cta-url");
            if (link && ctaUrl) link.setAttribute("href", ctaUrl);
          }
          openDialog(dlg);
          initFocus(dlg);
          // direkt zur Übersichtskarte gescrollt öffnen
          requestAnimationFrame(function () {
            var track = dlg.querySelector(".jz-focus__track");
            if (track) track.scrollLeft = track.scrollWidth;
          });
        });
      }
    });
  }

  /* ---- Bento: Klick auf Bild-Kachel öffnet Galerie über alle Kachel-Bilder (Desktop) ---- */
  function initBento(root) {
    root.querySelectorAll("[data-jz-bento]:not(.jz-bound)").forEach(function (sec) {
      sec.classList.add("jz-bound");
      var cells = Array.prototype.slice.call(sec.querySelectorAll("[data-jz-bento-img]"));
      var dlg = sec.querySelector("[data-jz-bento-dialog]");
      if (!cells.length || !dlg) return;
      bindDialog(dlg);
      var img = dlg.querySelector("[data-jz-dialog-img]");
      var counter = dlg.querySelector("[data-jz-bento-counter]");
      var prev = dlg.querySelector(".jz-bento__nav-prev");
      var next = dlg.querySelector(".jz-bento__nav-next");
      var urls = cells.map(function (c) { return c.getAttribute("data-jz-bento-img"); });
      var idx = 0;
      function show(i) {
        idx = (i + urls.length) % urls.length;
        if (img) img.src = urls[idx];
        if (counter) counter.textContent = (idx + 1) + " / " + urls.length;
      }
      function isDesktop() { return window.matchMedia("(min-width: 750px)").matches; }
      cells.forEach(function (c, i) {
        c.addEventListener("click", function () { if (!isDesktop()) return; show(i); openDialog(dlg); });
        c.addEventListener("keydown", function (e) {
          if ((e.key === "Enter" || e.key === " ") && isDesktop()) { e.preventDefault(); show(i); openDialog(dlg); }
        });
      });
      if (prev) prev.addEventListener("click", function () { show(idx - 1); });
      if (next) next.addEventListener("click", function () { show(idx + 1); });
    });
  }

  /* ---- Fokus-Slider: 2 Zustände (Bild bündig <-> Karte hereingewischt) ---- */
  function initFocus(root) {
    root.querySelectorAll("[data-jz-focus]:not(.jz-bound)").forEach(function (sec) {
      sec.classList.add("jz-bound");
      var track = sec.querySelector(".jz-focus__track");
      if (!track) return;
      var prev = sec.querySelector(".jz-focus__prev");
      var next = sec.querySelector(".jz-focus__next");
      var dots = sec.querySelectorAll(".jz-focus__dots button");
      function maxScroll() { return Math.max(0, track.scrollWidth - track.clientWidth); }
      function state() { return track.scrollLeft > maxScroll() / 2 ? 1 : 0; }
      function go(s) { track.scrollTo({ left: s === 1 ? maxScroll() : 0, behavior: "smooth" }); }
      function sync() {
        var a = state();
        dots.forEach(function (d, i) { d.setAttribute("aria-current", String(i === a)); });
        if (prev) prev.hidden = a === 0;
        if (next) next.hidden = a === 1;
      }
      if (prev) prev.addEventListener("click", function () { go(0); });
      if (next) next.addEventListener("click", function () { go(1); });
      dots.forEach(function (d, i) { d.addEventListener("click", function () { go(i); }); });
      track.addEventListener("scroll", function () { window.requestAnimationFrame(sync); }, { passive: true });
      sync();
    });
  }

  /* ---- Dialog-Hilfen ---- */
  function openDialog(dlg) {
    if (!dlg) return;
    if (typeof dlg.showModal === "function") dlg.showModal();
    else dlg.setAttribute("open", "");
    document.documentElement.style.overflow = "hidden";
  }
  function closeDialog(dlg) {
    if (!dlg) return;
    if (typeof dlg.close === "function") dlg.close();
    else dlg.removeAttribute("open");
    document.documentElement.style.overflow = "";
  }
  function bindDialog(dlg) {
    if (!dlg || dlg.classList.contains("jz-bound")) return;
    dlg.classList.add("jz-bound");
    dlg.querySelectorAll("[data-jz-close]").forEach(function (btn) {
      btn.addEventListener("click", function () { closeDialog(dlg); });
    });
    dlg.addEventListener("close", function () { document.documentElement.style.overflow = ""; });
    dlg.addEventListener("click", function (e) { if (e.target === dlg) closeDialog(dlg); });
  }

  /* ---- Galerie: Zentrier-Snap, Dots, Pfeile, Klick-Popup, Endlos-Loop ---- */
  function initGallery(root) {
    root.querySelectorAll("[data-jz-gallery]:not(.jz-bound)").forEach(function (sec) {
      sec.classList.add("jz-bound");
      var track = sec.querySelector(".jz-gallery__track");
      var origSlides = Array.prototype.slice.call(sec.querySelectorAll(".jz-gallery__slide"));
      var dotsWrap = sec.querySelector(".jz-gallery__dots");
      var prev = sec.querySelector(".jz-gallery__prev");
      var next = sec.querySelector(".jz-gallery__next");
      var dialogs = sec.querySelectorAll("[data-jz-dialog]");
      if (!track || !origSlides.length) return;
      dialogs.forEach(bindDialog);

      var n = origSlides.length;
      var loop = sec.hasAttribute("data-jz-loop") && n > 1;

      // Endlos-Loop: je einen kompletten Klon-Satz vor und nach den Originalen
      if (loop) {
        sec.classList.add("jz-gallery--loop");
        var frag = document.createDocumentFragment();
        origSlides.forEach(function (s) { frag.appendChild(s.cloneNode(true)); });
        track.appendChild(frag);
        for (var k = n - 1; k >= 0; k--) track.insertBefore(origSlides[k].cloneNode(true), track.firstChild);
      }
      var slides = Array.prototype.slice.call(track.querySelectorAll(".jz-gallery__slide"));
      var mid = loop ? n : 0; // Startindex des Original-Sets

      function jump(delta) {
        track.style.scrollBehavior = "auto";
        track.scrollLeft += delta;
        track.style.scrollBehavior = "";
      }
      function setWidth() { return loop ? slides[mid + n].offsetLeft - slides[mid].offsetLeft : 0; }

      function center(i, instant) {
        var s = slides[i]; if (!s) return;
        var left = s.offsetLeft - (track.clientWidth - s.clientWidth) / 2;
        if (instant) { track.style.scrollBehavior = "auto"; track.scrollLeft = left; track.style.scrollBehavior = ""; }
        else track.scrollTo({ left: left, behavior: "smooth" });
      }
      function active() {
        var m = track.scrollLeft + track.clientWidth / 2, best = 0, bestD = Infinity;
        slides.forEach(function (s, i) {
          var c = s.offsetLeft + s.clientWidth / 2, d = Math.abs(c - m);
          if (d < bestD) { bestD = d; best = i; }
        });
        return best;
      }
      function logical(i) { return loop ? (((i - mid) % n) + n) % n : i; }

      // Dots erzeugen (immer n Stück, springen ins Original-Set)
      if (dotsWrap) {
        origSlides.forEach(function (_, i) {
          var b = document.createElement("button");
          b.setAttribute("aria-label", "Bild " + (i + 1));
          b.addEventListener("click", function () { center(mid + i); });
          dotsWrap.appendChild(b);
        });
      }

      function sync() {
        var a = active(), lg = logical(a);
        slides.forEach(function (s, i) { s.classList.toggle("jz-current", i === a); });
        if (dotsWrap) dotsWrap.querySelectorAll("button").forEach(function (d, i) { d.setAttribute("aria-current", String(i === lg)); });
        if (prev) prev.hidden = !loop && a === 0;
        if (next) next.hidden = !loop && a === slides.length - 1;
      }

      // Nach Scroll-Ruhe: aus der Klonzone unsichtbar ins Original-Set springen
      var idleTimer = null;
      function normalize() {
        if (!loop) return;
        var sw = setWidth(); if (!sw) return;
        if (track.scrollLeft < sw * 0.5) jump(sw);
        else if (track.scrollLeft > sw * 1.5) jump(-sw);
      }
      track.addEventListener("scroll", function () {
        window.requestAnimationFrame(sync);
        if (loop) { clearTimeout(idleTimer); idleTimer = setTimeout(normalize, 160); }
      }, { passive: true });

      if (prev) prev.addEventListener("click", function () { center(active() - 1); });
      if (next) next.addEventListener("click", function () { center(active() + 1); });

      // Klick: aktuelles Bild im passenden Dialog öffnen (Klickverhalten je Slide)
      slides.forEach(function (s, i) {
        s.addEventListener("click", function () {
          if (!s.classList.contains("jz-current")) { center(i); return; }
          var action = s.getAttribute("data-jz-action") || "focus";
          var dlg = sec.querySelector('[data-jz-dialog="' + action + '"]') || sec.querySelector("[data-jz-dialog]");
          if (!dlg) return;
          var img = dlg.querySelector("[data-jz-dialog-img]");
          if (img) img.src = s.getAttribute("data-full") || (s.querySelector("img") || {}).currentSrc || "";
          if (action === "info") {
            var t = dlg.querySelector("[data-jz-info-title]");
            var x = dlg.querySelector("[data-jz-info-text]");
            if (t) t.textContent = s.getAttribute("data-info-title") || "";
            if (x) x.textContent = s.getAttribute("data-info-text") || "";
          }
          // Kaufkarte (focus/split) mit den Daten des Slides befüllen
          if (action === "focus" || action === "split") {
            var cName = dlg.querySelector("[data-jz-card-name]");
            var cSpec = dlg.querySelector("[data-jz-card-spec]");
            var cCut = dlg.querySelector("[data-jz-card-cutout]");
            var cLink = dlg.querySelector("[data-jz-card-link]");
            var cVar = dlg.querySelector('form input[name="id"]');
            var v;
            if (cName && (v = s.getAttribute("data-card-name"))) cName.textContent = v;
            if (cSpec) { v = s.getAttribute("data-card-spec") || ""; cSpec.textContent = v; cSpec.style.display = v ? "" : "none"; }
            if (cCut && (v = s.getAttribute("data-card-cutout"))) cCut.src = v;
            if (cLink && (v = s.getAttribute("data-card-url"))) cLink.href = v;
            if (cVar && (v = s.getAttribute("data-card-variant"))) cVar.value = v;
          }
          var innerTrack = dlg.querySelector(".jz-focus__track");
          if (innerTrack) { innerTrack.style.scrollBehavior = "auto"; innerTrack.scrollLeft = 0; innerTrack.style.scrollBehavior = ""; }
          openDialog(dlg);
          initFocus(dlg);
        });
      });

      // Start: erstes Original zentrieren (im Loop liegt es hinter dem Klon-Satz).
      // Nach window.load erneut, weil sich offsetLeft mit geladenen Bildern verschiebt.
      function boot() { center(mid, true); sync(); }
      boot();
      if (document.readyState !== "complete") window.addEventListener("load", boot, { once: true });
    });
  }

  /* ---- Cover-Hero: Titel fadet scroll-linked aus, Beschreibung fadet ein ---- */
  function initCover(root) {
    root.querySelectorAll("[data-jz-cover]:not(.jz-bound)").forEach(function (sec) {
      sec.classList.add("jz-bound");
      var title = sec.querySelector(".jz-cover__titlewrap");
      var desc = sec.querySelector(".jz-cover__desc");
      var reduced = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

      // Titel: fix am Viewport; Opacity 1 → 0 über das erste Viertel Scrollweg,
      // gekoppelt an den Seiten-Scroll (startet mit dem ersten Pixel).
      function tick() {
        if (!title) return;
        var y = window.scrollY || window.pageYOffset || 0;
        // Titel schnell ausfaden — Desktop noch schneller (weg nach 5% Scroll)
        var fadeDist = window.innerHeight * (window.innerWidth < 750 ? 0.13 : 0.05);
        var p = Math.max(0, Math.min(1, y / fadeDist));
        if (reduced) p = p > 0.3 ? 1 : 0; // ohne Animation: hart umschalten
        var op = 1 - p;
        title.style.opacity = String(op);
        title.style.visibility = op <= 0.01 ? "hidden" : "visible";
      }
      var raf = null;
      function requestTick() { if (raf) return; raf = requestAnimationFrame(function () { raf = null; tick(); }); }
      window.addEventListener("scroll", requestTick, { passive: true });
      window.addEventListener("resize", requestTick, { passive: true });
      tick();

      // Beschreibung: einblenden, sobald sie in den Viewport kommt
      // (Mobile: später — erst wenn sie großteils sichtbar ist)
      if (desc) {
        if ("IntersectionObserver" in window && !reduced) {
          var descThreshold = window.innerWidth < 750 ? 0.6 : 0.25;
          var io = new IntersectionObserver(function (entries) {
            entries.forEach(function (e) {
              desc.classList.toggle("jz-in", e.isIntersecting);
            });
          }, { threshold: descThreshold });
          io.observe(desc);
        } else {
          desc.classList.add("jz-in");
        }
      }
    });
  }

  /* ---- Kauf-Dock: scroll-gekoppeltes Hereinscrollen + Modal ---- */
  function initDock(root) {
    root.querySelectorAll("[data-jz-dock]:not(.jz-bound)").forEach(function (dock) {
      dock.classList.add("jz-bound");
      var marker = dock.querySelector("[data-jz-dock-marker]");
      var pill = dock.querySelector("[data-jz-dock-pill]");
      var top = dock.querySelector("[data-jz-dock-top]");
      var modal = dock.querySelector("[data-jz-dock-modal]");
      var dist = parseFloat(dock.getAttribute("data-jz-dock-distance") || "300");
      if (!marker || !pill) return;
      bindDialog(modal);
      pill.addEventListener("click", function () { openDialog(modal); });

      var reduced = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      function tick() {
        var r = marker.getBoundingClientRect();
        // Fortschritt: 0 solange Marker unter dem Viewport, 1 nach `dist` px Scrollweg
        var passed = window.innerHeight - r.top;
        var p = Math.max(0, Math.min(1, passed / dist));
        if (reduced) p = p > 0 ? 1 : 0;
        pill.style.transform = "translate(-50%, " + ((1 - p) * 140) + "%)";
        pill.style.opacity = String(Math.min(1, p * 1.6));
        pill.style.pointerEvents = p > 0.6 ? "auto" : "none";
        if (top) top.classList.toggle("jz-hidden", p > 0.4);
      }
      var raf = null;
      function requestTick() { if (raf) return; raf = requestAnimationFrame(function () { raf = null; tick(); }); }
      window.addEventListener("scroll", requestTick, { passive: true });
      window.addEventListener("resize", requestTick, { passive: true });
      tick();
    });
  }

  /* ---- Modell-Grid: Bild-Kachel öffnet die Fokus-Ansicht mit Kaufkarte ---- */
  function initGrid(root) {
    root.querySelectorAll("[data-jz-grid]:not(.jz-bound)").forEach(function (sec) {
      sec.classList.add("jz-bound");
      var dlg = sec.querySelector("[data-jz-grid-dialog]");
      if (!dlg) return;
      bindDialog(dlg);
      sec.querySelectorAll("[data-jz-grid-open]").forEach(function (tile) {
        tile.addEventListener("click", function () {
          var img = dlg.querySelector("[data-jz-dialog-img]");
          if (img) img.src = tile.getAttribute("data-full") || (tile.querySelector("img") || {}).currentSrc || "";
          var cName = dlg.querySelector("[data-jz-card-name]");
          var cSpec = dlg.querySelector("[data-jz-card-spec]");
          var cCut = dlg.querySelector("[data-jz-card-cutout]");
          var cLink = dlg.querySelector("[data-jz-card-link]");
          var cVar = dlg.querySelector('form input[name="id"]');
          var v;
          if (cName && (v = tile.getAttribute("data-card-name"))) cName.textContent = v;
          if (cSpec) { v = tile.getAttribute("data-card-spec") || ""; cSpec.textContent = v; cSpec.style.display = v ? "" : "none"; }
          if (cCut && (v = tile.getAttribute("data-card-cutout"))) cCut.src = v;
          if (cLink) { v = tile.getAttribute("data-card-url") || ""; cLink.href = v; cLink.style.display = v ? "" : "none"; }
          if (cVar && (v = tile.getAttribute("data-card-variant"))) cVar.value = v;
          var track = dlg.querySelector(".jz-focus__track");
          if (track) { track.style.scrollBehavior = "auto"; track.scrollLeft = 0; track.style.scrollBehavior = ""; }
          openDialog(dlg);
          initFocus(dlg);
        });
      });
    });
  }

  /* ---- Zifferblatt-Wahl: Zifferblatt fliegt hinter die Uhr, neuer Freisteller fadet ein ---- */
  function initDialPicker(root) {
    root.querySelectorAll("[data-jz-dial]:not(.jz-bound)").forEach(function (sec) {
      sec.classList.add("jz-bound");
      var stage = sec.querySelector("[data-jz-dial-stage]");
      var label = sec.querySelector("[data-jz-dial-label]");
      var cta = sec.querySelector("[data-jz-dial-cta]");
      var busy = false;
      sec.querySelectorAll("[data-jz-dial-pick]").forEach(function (btn) {
        btn.addEventListener("click", function () {
          if (busy || !stage) return;
          busy = true;
          var key = btn.getAttribute("data-key");
          function apply() {
            stage.querySelectorAll(".jz-dial__cutout").forEach(function (img) {
              img.classList.toggle("jz-active", img.getAttribute("data-key") === key);
            });
            sec.querySelectorAll("[data-jz-dial-pick]").forEach(function (b) {
              b.hidden = b.getAttribute("data-key") === key;
            });
            if (label) label.textContent = btn.getAttribute("data-name") || "";
            var url = btn.getAttribute("data-url");
            if (cta && url) cta.setAttribute("href", url);
          }
          var disc = btn.querySelector("img");
          var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
          if (reduce || !disc || !disc.animate) { apply(); busy = false; return; }
          // Klon des Zifferblatts fliegt hinter die Uhr (Stage hat z-index 2, Klon 1)
          var from = disc.getBoundingClientRect();
          var to = stage.getBoundingClientRect();
          var clone = disc.cloneNode();
          clone.className = "jz-dial__fly";
          clone.style.cssText = "position:fixed;left:" + from.left + "px;top:" + from.top + "px;width:" + from.width + "px;height:" + from.height + "px;z-index:1;margin:0;pointer-events:none;";
          document.body.appendChild(clone);
          var dx = to.left + to.width / 2 - (from.left + from.width / 2);
          var dy = to.top + to.height / 2 - (from.top + from.height / 2);
          var scale = (to.width * 0.55) / from.width;
          var anim = clone.animate(
            [
              { transform: "translate(0,0) scale(1)", opacity: 1 },
              { transform: "translate(" + dx + "px," + dy + "px) scale(" + scale + ")", opacity: 0 }
            ],
            { duration: 650, easing: "cubic-bezier(.4,0,.2,1)" }
          );
          // Crossfade startet, während das Zifferblatt hinter der Uhr verschwindet
          setTimeout(apply, 400);
          anim.onfinish = function () { clone.remove(); busy = false; };
        });
      });
    });
  }

  function initAll(root) {
    root = root || document;
    initReveal(root);
    initPickers(root);
    initDialPicker(root);
    initGrid(root);
    initFocus(root);
    initGallery(root);
    initBento(root);
    initCover(root);
    initDock(root);
  }

  if (document.readyState !== "loading") initAll(document);
  else document.addEventListener("DOMContentLoaded", function () { initAll(document); });

  // Theme-Editor: neu geladene Section initialisieren
  document.addEventListener("shopify:section:load", function (e) { initAll(e.target); });
})();
